(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Sticky header elevation */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Reveal on scroll */
  var reveals = document.querySelectorAll('.reveal-on-scroll');
  if (reveals.length) {
    if (reduce || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
      reveals.forEach(function (el) { io.observe(el); });
    }
  }

  /* Light card tilt */
  if (!reduce) {
    document.querySelectorAll('.card--product').forEach(function (card) {
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'translateY(-6px) rotateX(' + (-y * 3) + 'deg) rotateY(' + (x * 3) + 'deg)';
      });
      card.addEventListener('pointerleave', function () {
        card.style.transform = '';
      });
    });
  }

  /* Ken burns pause if reduced motion */
  if (reduce) {
    document.querySelectorAll('.banner--ken-burns .banner__image').forEach(function (img) {
      img.style.animation = 'none';
    });
  }

  /* Flying R.W — restart animation offset per instance for less spammy feel */
  if (!reduce) {
    document.querySelectorAll('[data-flying-rw] .flying-rw__mark').forEach(function (mark, i) {
      mark.style.animationDelay = (-(i * 7 + 2)) + 's';
    });
  }

  /* Mobile menu close on escape */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var toggle = document.querySelector('[data-menu-toggle]');
    var drawer = document.getElementById('HeaderDrawer');
    if (toggle && drawer && toggle.getAttribute('aria-expanded') === 'true') {
      toggle.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('hidden', '');
    }
  });

  /* 3bood Miku was here */
  /* Eggs: header RW diamond = 5× wound-up;
     footer Dubai-based . = 11× “3bood miku was here” */
  (function () {
    function clearSel(sel) {
      document.querySelectorAll(sel).forEach(function (n) { n.remove(); });
    }

    function formatNow() {
      try {
        return new Intl.DateTimeFormat(undefined, {
          hour: 'numeric',
          minute: '2-digit',
          hour12: true
        }).format(new Date());
      } catch (e) {
        var d = new Date();
        var h = d.getHours();
        var m = d.getMinutes();
        var ap = h >= 12 ? 'PM' : 'AM';
        h = h % 12; if (!h) h = 12;
        return h + ':' + (m < 10 ? '0' : '') + m + ' ' + ap;
      }
    }

    function showWoundToast() {
      clearSel('.rw-egg-toast');
      var el = document.createElement('div');
      el.className = 'rw-egg-toast rw-egg-toast--time';
      el.setAttribute('role', 'status');
      el.innerHTML =
        '<span class="rw-egg-toast__mark" aria-hidden="true">◆</span>' +
        '<span class="rw-egg-toast__text">Don\'t worry — our watches are wound up.</span>' +
        '<span class="rw-egg-toast__sub">It\'s ' + formatNow() + '</span>';
      document.body.appendChild(el);
      requestAnimationFrame(function () { el.classList.add('is-in'); });
      setTimeout(function () {
        el.classList.remove('is-in');
        el.classList.add('is-out');
        setTimeout(function () { el.remove(); }, 500);
      }, 4200);
    }

    function showMikuToast() {
      clearSel('.rw-egg-toast, .rw-egg-whisper, .rw-egg-miku');
      var el = document.createElement('div');
      el.className = 'rw-egg-toast rw-egg-toast--miku';
      el.setAttribute('role', 'status');
      el.innerHTML =
        '<span class="rw-egg-toast__mark" aria-hidden="true">◆</span>' +
        '<span class="rw-egg-toast__text">3bood miku was here</span>';
      document.body.appendChild(el);
      requestAnimationFrame(function () { el.classList.add('is-in'); });
      setTimeout(function () {
        el.classList.remove('is-in');
        el.classList.add('is-out');
        setTimeout(function () { el.remove(); }, 500);
      }, 3200);
    }

    /* Header diamond — 5 taps only */
    (function () {
      var link = document.querySelector('a[data-rw-egg="diamond"]');
      if (!link) return;
      var taps = [];
      var navTimer = null;
      var homeHref = link.getAttribute('href') || '/';
      var WINDOW_MS = 2000;

      link.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var now = Date.now();
        taps = taps.filter(function (t) { return now - t < WINDOW_MS; });
        taps.push(now);
        if (navTimer) clearTimeout(navTimer);

        if (taps.length >= 5) {
          taps = [];
          showWoundToast();
          navTimer = setTimeout(function () {
            window.location.href = homeHref;
          }, 700);
          return;
        }

        navTimer = setTimeout(function () {
          taps = [];
          window.location.href = homeHref;
        }, 650);
      }, true);
    })();

    /* Footer Dubai-based. — 11 taps */
    (function () {
      var target = document.querySelector('[data-rw-egg="miku"]');
      if (!target) return;
      var taps = [];
      var WINDOW_MS = 3500;
      var locked = false;

      target.addEventListener('click', function (e) {
        e.preventDefault();
        if (locked) return;
        var now = Date.now();
        taps = taps.filter(function (t) { return now - t < WINDOW_MS; });
        taps.push(now);
        if (taps.length >= 11) {
          taps = [];
          locked = true;
          showMikuToast();
          setTimeout(function () { locked = false; }, 3500);
        }
      });
    })();
  })();









  /* Badge tooltips — NOS + Gone (tap on mobile, hover on desktop) */
  (function () {
    var tipTimer = null;
    var tipSel = '.badge--nos, .badge--sold-out';
    function hideAll() {
      document.querySelectorAll('.badge--nos.is-tip, .badge--sold-out.is-tip').forEach(function (el) {
        el.classList.remove('is-tip');
      });
    }
    document.addEventListener('click', function (e) {
      var badge = e.target.closest && e.target.closest(tipSel);
      if (!badge || !badge.getAttribute('data-tooltip')) {
        hideAll();
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      var open = badge.classList.contains('is-tip');
      hideAll();
      if (!open) {
        badge.classList.add('is-tip');
        if (tipTimer) clearTimeout(tipTimer);
        tipTimer = setTimeout(hideAll, 2200);
      }
    }, true);
  })();


  /* Product sheet — unify From the hunt + specs table + as-is */
  (function () {
    function splitLabel(text) {
      var m = text.match(/^([^:–—]+)\s*[:–—]\s*(.+)$/);
      if (!m) return null;
      return { label: m[1].replace(/^\s+|\s+$/g, ''), value: m[2].replace(/^\s+|\s+$/g, '') };
    }

    function isSpecsHeading(el) {
      if (!el) return false;
      var t = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      return t === 'specs' || t === 'specifications' || t.indexOf('specs') === 0;
    }

    function buildTable(rows) {
      var table = document.createElement('table');
      table.className = 'product__specs';
      table.setAttribute('role', 'table');
      var body = document.createElement('tbody');
      rows.forEach(function (row) {
        var tr = document.createElement('tr');
        var th = document.createElement('th');
        th.scope = 'row';
        th.textContent = row.label;
        var td = document.createElement('td');
        td.textContent = row.value;
        tr.appendChild(th);
        tr.appendChild(td);
        body.appendChild(tr);
      });
      table.appendChild(body);
      return table;
    }

    function enhance(sheet) {
      var body = sheet.querySelector('[data-product-sheet-body]');
      if (!body || body.getAttribute('data-sheet-ready')) return;
      body.setAttribute('data-sheet-ready', '1');

      var nodes = Array.prototype.slice.call(body.childNodes);
      var specsList = null;
      var specsHeading = null;
      var asIs = null;

      body.querySelectorAll('ul, ol').forEach(function (list) {
        var items = Array.prototype.slice.call(list.children).filter(function (li) {
          return li.tagName === 'LI';
        });
        if (items.length < 2) return;
        var parsed = [];
        items.forEach(function (li) {
          var pair = splitLabel((li.textContent || '').replace(/\s+/g, ' ').trim());
          if (pair) parsed.push(pair);
        });
        if (parsed.length >= 2 && parsed.length >= Math.ceil(items.length * 0.6)) {
          specsList = list;
        }
      });

      if (specsList) {
        var prev = specsList.previousElementSibling;
        if (isSpecsHeading(prev)) {
          specsHeading = prev;
        }
        var rows = [];
        Array.prototype.forEach.call(specsList.children, function (li) {
          if (li.tagName !== 'LI') return;
          var pair = splitLabel((li.textContent || '').replace(/\s+/g, ' ').trim());
          if (pair) rows.push(pair);
        });
        if (rows.length) {
          var wrap = document.createElement('div');
          wrap.className = 'product__specs-wrap';
          var label = document.createElement('p');
          label.className = 'product__specs-kicker';
          label.textContent = 'Specs';
          wrap.appendChild(label);
          wrap.appendChild(buildTable(rows));
          specsList.parentNode.insertBefore(wrap, specsList);
          specsList.parentNode.removeChild(specsList);
          if (specsHeading) specsHeading.parentNode.removeChild(specsHeading);
        }
      }

      // As-is line → footer stamp
      body.querySelectorAll('p').forEach(function (p) {
        var txt = (p.textContent || '').replace(/\s+/g, ' ').trim();
        if (/^sold as-is/i.test(txt) || /no warranty/i.test(txt)) {
          p.classList.add('product__sheet-asis');
          asIs = p;
        }
      });

      // Drop empty leftovers
      body.querySelectorAll('p').forEach(function (p) {
        if (!(p.textContent || '').trim() && !p.querySelector('img')) p.remove();
      });
    }

    function run() {
      document.querySelectorAll('[data-product-sheet]').forEach(enhance);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', run);
  })();



  /* Cart drawer — AJAX add, no redirect */
  (function () {
    var drawer = document.querySelector('[data-rw-cart-drawer]');
    if (!drawer) return;
    var linesEl = drawer.querySelector('[data-rw-cart-lines]');
    var subEl = drawer.querySelector('[data-rw-cart-subtotal]');
    var lastCart = null;
    var moneyFmt = function (cents) {
      var c = Number(cents) || 0;
      if (c <= 0) return '0 AED';
      var n = Math.round((c + 50) / 100) * 100;
      var whole = String(Math.round(n / 100));
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' AED';
    };

    function cartQtyForVariant(cart, variantId) {
      var n = 0;
      var id = Number(variantId);
      if (!cart || !cart.items) return 0;
      cart.items.forEach(function (item) {
        if (Number(item.variant_id) === id) n += item.quantity || 0;
      });
      return n;
    }

    function formMaxQty(form) {
      var raw = form.getAttribute('data-rw-max-qty');
      if (raw == null || raw === '') {
        var idEl = form.querySelector('.product-variant-id, [name="id"]');
        if (idEl) raw = idEl.getAttribute('data-rw-max-qty');
      }
      var max = Number(raw);
      if (!isFinite(max) || max < 0) max = 99;
      return max;
    }

    function syncProductForms(cart) {
      document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function (form) {
        var idEl = form.querySelector('[name="id"]');
        var btn = form.querySelector('[type="submit"]');
        var label = form.querySelector('.product-form__submit-label');
        if (!idEl || !btn || btn.classList.contains('is-unavailable')) return;
        var variantId = Number(idEl.value);
        var max = formMaxQty(form);
        var inCart = cartQtyForVariant(cart, variantId);
        var remaining = Math.max(0, max - inCart);
        var qtyInput = form.querySelector('[name="quantity"]');
        if (qtyInput) {
          qtyInput.setAttribute('max', String(Math.max(remaining, 0)));
          if (remaining >= 1 && Number(qtyInput.value) > remaining) qtyInput.value = String(remaining);
        }
        if (remaining < 1) {
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
          btn.classList.add('button--sold-out');
          if (label) label.textContent = inCart > 0 ? 'In the bag' : 'Gone';
        } else {
          btn.disabled = false;
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('button--sold-out');
          if (label) label.textContent = 'Add to cart';
        }
      });
    }

    function openDrawer() {
      drawer.hidden = false;
      document.documentElement.classList.add('rw-cart-open');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      });
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('rw-cart-open');
      setTimeout(function () { drawer.hidden = true; }, 230);
    }

    function updateCount(count) {
      document.querySelectorAll('[data-rw-cart-count]').forEach(function (bubble) {
        var num = bubble.querySelector('[data-rw-cart-count-num]');
        if (num) num.textContent = String(count);
        if (count > 0) {
          bubble.hidden = false;
          bubble.classList.remove('is-empty');
        } else {
          bubble.hidden = true;
          bubble.classList.add('is-empty');
        }
      });
    }

    var checkoutEl = drawer.querySelector('[data-rw-cart-view-primary]') || drawer.querySelector('[data-rw-cart-checkout]');
    var viewEl = drawer.querySelector('[data-rw-cart-view]');
    var footEl = drawer.querySelector('[data-rw-cart-foot]');

    function setEmptyState(isEmpty) {
      if (footEl) footEl.setAttribute('data-empty', isEmpty ? 'true' : 'false');
      if (checkoutEl) {
        if (isEmpty) {
          checkoutEl.setAttribute('hidden', 'hidden');
          checkoutEl.setAttribute('aria-disabled', 'true');
          checkoutEl.setAttribute('tabindex', '-1');
          checkoutEl.removeAttribute('href');
        } else {
          checkoutEl.removeAttribute('hidden');
          checkoutEl.removeAttribute('aria-disabled');
          checkoutEl.removeAttribute('tabindex');
          checkoutEl.setAttribute('href', '/cart');
          checkoutEl.textContent = 'View cart';
        }
      }
      if (viewEl) {
        if (isEmpty) {
          viewEl.hidden = false;
          viewEl.textContent = 'Browse timepieces';
          viewEl.setAttribute('href', '/collections/all');
        } else {
          viewEl.hidden = true;
        }
      }
    }

    function renderCart(cart) {
      if (!linesEl || !subEl) return;
      lastCart = cart;
      syncProductForms(cart);
      var count = cart.item_count || 0;
      var isEmpty = !cart.items || !cart.items.length || count < 1;
      updateCount(count);
      subEl.textContent = moneyFmt(isEmpty ? 0 : (cart.total_price || 0));
      setEmptyState(isEmpty);
      if (isEmpty) {
        linesEl.innerHTML = '<div class="rw-cart-drawer__empty-wrap">' +
          '<p class="rw-cart-drawer__empty-kicker">Still hunting</p>' +
          '<p class="rw-cart-drawer__empty">Nothing in the bag yet.</p>' +
          '<p class="rw-cart-drawer__empty-sub">The rarities are waiting.</p>' +
        '</div>';
        return;
      }
      linesEl.innerHTML = cart.items.map(function (item) {
        var img = item.image
          ? '<img class="rw-cart-drawer__img" src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt="" width="72" height="72" loading="lazy">'
          : '<span class="rw-cart-drawer__img rw-cart-drawer__img--ph"></span>';
        var key = item.key || String(item.variant_id);
        return (
          '<article class="rw-cart-drawer__line">' +
            '<a class="rw-cart-drawer__thumb" href="' + item.url + '">' + img + '</a>' +
            '<div class="rw-cart-drawer__meta">' +
              '<a class="rw-cart-drawer__title" href="' + item.url + '">' + item.product_title + '</a>' +
              '<p class="rw-cart-drawer__price">' + moneyFmt(item.final_line_price) + '</p>' +
              '<div class="rw-cart-drawer__row">' +
                '<p class="rw-cart-drawer__qty">Qty ' + item.quantity + '</p>' +
                '<button type="button" class="rw-cart-drawer__remove" data-rw-cart-remove="' + key.replace(/"/g, '&quot;') + '">Remove</button>' +
              '</div>' +
            '</div>' +
          '</article>'
        );
      }).join('');
    }

    function fetchCart() {
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-rw-cart-close]')) {
        e.preventDefault();
        closeDrawer();
      }
      var removeBtn = e.target.closest && e.target.closest('[data-rw-cart-remove]');
      if (removeBtn) {
        e.preventDefault();
        var lineKey = removeBtn.getAttribute('data-rw-cart-remove');
        if (!lineKey) return;
        removeBtn.setAttribute('disabled', 'disabled');
        fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: 0 })
        }).then(function (r) {
          if (!r.ok) throw new Error('remove failed');
          return r.json();
        }).then(function (cart) {
          renderCart(cart);
        }).catch(function () {
          removeBtn.removeAttribute('disabled');
        });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    document.addEventListener('click', function (e) {
      var go = e.target.closest && e.target.closest('[data-rw-cart-view-primary], [data-rw-cart-checkout]');
      if (!go) return;
      if (go.hasAttribute('hidden') || go.getAttribute('aria-disabled') === 'true' || !go.getAttribute('href')) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var idInput = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      var variantId = idInput ? Number(idInput.value) : 0;
      var qty = qtyInput ? Math.max(1, Number(qtyInput.value) || 1) : 1;
      var max = formMaxQty(form);

      function proceedAdd(cart) {
        lastCart = cart || lastCart || { items: [], item_count: 0 };
        var inCart = cartQtyForVariant(lastCart, variantId);
        var remaining = Math.max(0, max - inCart);
        if (!variantId || remaining < 1) {
          syncProductForms(lastCart);
          openDrawer();
          renderCart(lastCart);
          return Promise.resolve();
        }
        if (qty > remaining) qty = remaining;

        if (btn) {
          btn.setAttribute('disabled', 'disabled');
          btn.setAttribute('aria-busy', 'true');
        }
        if (linesEl) linesEl.innerHTML = '<p class="rw-cart-drawer__loading">Adding…</p>';
        openDrawer();

        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
        }).then(function (r) {
          if (r.status === 422 || r.status === 409) {
            return fetchCart().then(function (c) {
              renderCart(c);
              return null;
            });
          }
          if (!r.ok) throw new Error('add failed');
          return fetchCart();
        }).then(function (cart) {
          if (cart) renderCart(cart);
        }).catch(function () {
          /* do not full-page submit — that can oversell; refresh cart instead */
          return fetchCart().then(function (c) { renderCart(c); });
        }).finally(function () {
          if (btn) btn.removeAttribute('aria-busy');
          syncProductForms(lastCart || { items: [], item_count: 0 });
        });
      }

      if (lastCart) proceedAdd(lastCart);
      else fetchCart().then(proceedAdd).catch(function () { proceedAdd({ items: [], item_count: 0 }); });
    });

    /* rw-inv-boot — sync ATC with bag on load */
    fetchCart().then(function (cart) {
      lastCart = cart;
      syncProductForms(cart);
      updateCount(cart.item_count || 0);
    }).catch(function () {});
  })();


})();
